module.exports = __webpack_public_path__ + "static/media/ant.ddeaeadf.jpg";